// Module
var code = "<h2 id=\"borrowers\">Borrowers</h2> <p>Borrowers can <a href=\"/Authorizations\" target=\"_blank\">sign in to Account Access</a> to complete the Authorizations Agreement Process or print, sign, and mail your application to the address provided.</p> ";
// Exports
export default code;